import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import { store } from '@/store'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
import ProgressBar from 'vuejs-progress-bar'
import { PermissionPlugin } from '@/directives/permission'
import { ToastPlugin } from '@/plugins/toast'

const bounceTransition = createSimpleTransition('bounce-transition')

Vue.component('bounce-transition', bounceTransition)

Vue.config.productionTip = false

Vue.use(ProgressBar)
Vue.use(PermissionPlugin)
Vue.use(ToastPlugin)

const app = new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
})
app.$toast.init(store)
app.$mount('#app')
